export default "__VITE_ASSET__a41106d9__"